/**
 * Keeps `data-size` on print selectors in step with the size control, so a selector only offers prints
 * the shopper can buy in the size they picked.
 *
 * Bound to `change`, not `ThemeEvents.variantUpdate`: the picker dispatches that only once
 * `fetchUpdatedSection` has re-rendered and morphed the section, so the selector's request would queue
 * behind a whole round trip. The size is known the moment the input changes.
 *
 * The size lives in the picker's markup, so that knowledge stays here and the component's only input
 * is the attribute. `contains 'size'` matches the theme's own test for the size guide link, so
 * "Blazer Size" and "Pant Size" count too.
 */
document.addEventListener('change', (event) => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement || input instanceof HTMLSelectElement)) return;

  const option = input.closest('[data-option-name]');
  if (!(option instanceof HTMLElement) || !option.dataset.optionName?.toLowerCase().includes('size')) return;

  const size = input.value;
  if (!size) return;

  // A dialog's selectors belong to the control inside it, never to the page behind.
  const scope = input.closest('dialog') ?? input.closest('.shopify-section, featured-product-information');

  for (const selector of scope?.querySelectorAll('ss-print-swatches') ?? []) {
    if (selector instanceof HTMLElement && selector.dataset.size !== size) selector.dataset.size = size;
  }
});
